import { API_URL } from "../../config/connect";

const getAuthHeaders = () => {
  const token = localStorage.getItem('google_id_token');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

/**
 * Get Activity Logs (Monitoring)
 * GET /api/v1/sales-manager/activity-logs
 * @param {Object} params - Query parameters
 * @param {number} params.page - Page number (default: 1)
 * @param {number} params.limit - Items per page (default: 10, max: 100)
 * @param {number} params.user_id - Filter by user ID
 * @param {string} params.action_type - Filter by action type
 * @param {string} params.entity_type - Filter by entity type
 * @param {string} params.start_date - Start date in ISO format
 * @param {string} params.end_date - End date in ISO format
 * @returns {Promise<Object>} List of activity logs with pagination
 */
export const getActivityLogs = async (params = {}) => {
  try {
    let url = `${API_URL}/api/v1/sales-manager/activity-logs`;
    const queryParams = new URLSearchParams();
    
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.user_id) queryParams.append('user_id', params.user_id);
    if (params.action_type) queryParams.append('action_type', params.action_type);
    if (params.entity_type) queryParams.append('entity_type', params.entity_type);
    if (params.start_date) queryParams.append('start_date', params.start_date);
    if (params.end_date) queryParams.append('end_date', params.end_date);
    
    if (queryParams.toString()) {
      url += `?${queryParams.toString()}`;
    }

    const response = await fetch(url, {
      headers: getAuthHeaders()
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ detail: response.statusText }));
      throw new Error(errorData.detail || errorData.message || `HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching activity logs:', error);
    throw error;
  }
};






